import axios from "axios"
import { error } from "jquery"
import { del, get, post, postFile, put, postData, postFileV2} from "./api_helper"
import * as url from "./url_helper"
import {ToastHelper} from './alerts/alertHelper';
// Gets the logged in user data from local session
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

const getLoggedInUser = () => {
    const user = localStorage.getItem("authUser")
    if (user) return JSON.parse(user)
        return null
}

//is user is logged in
const isUserAuthenticated = () => {
    return getLoggedInUser() !== null
}
//reset pasword
export const userResetPasw = user => post(url.RESET_PASSW, user)
export const changePassw = data => post(url.CHANGE_PASSW, data)
export const sendConfirmation = data => post(url.SEND_CONFIRMATION, data)

// Login Method

export const postLoginToken = (data) => {
    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };

    return axios
    .post(process.env.REACT_APP_BACKEND_API_URL + url.POST_LOGIN_TOKEN, data, { headers: headers })
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data
          throw response.data
    })
    .catch(err => {
        console.log('err', err.response.data);
        var message = ''
        if (err.response && err.response.status) {
            switch (err.response.status) {
            case 404:
                message = "Sorry! the page you are looking for could not be found"
                break
            case 422:
                ToastHelper(err.response.data.message,'error')
                message = err.response.data.message
                break
            case 500:
                ToastHelper('¡Error!','error')
                message =
                "Sorry! something went wrong, please contact our support team"
                break
            case 401:
                ToastHelper('Credenciales inválidas','error')
                message = "Credenciales inválidas"
                break
            default:
                message = err.response?.data?.message || err.message
                break
            }
        } else {
            message = err.message
        }
        throw message
    })
}

export const getShowPdfUrl = (id, userId) => {
    return BACKEND_URL + '/installations' + '/' + id + '/' + userId
}

// get Users
export const GET_ME = "/user";
export const getUsers = (config) => get(url.RESOURCE_USERS,config);
export const postUser = user => post(url.RESOURCE_USERS, user)
export const putUser = user => put(`${url.RESOURCE_USERS}/${user.id}`, user)
export const deleteUser = id => del(`${url.RESOURCE_USERS}/${id}`)
export const getProfiles = (id) => get(`${url.RESOURCE_USERS}/${id}`);
export const changePassword = (id, data) => post(`${url.CHANGE_PASSWORD}/${id}`, data);
export const postFileProfile = (id,data) => postFile(`${url.FILE_PROFILE_USER}/${id}`, data)
//catalogs
export const getProfilescat = ()  => get(url.GET_PROFILES);
//condiguration
export const getConfigurations = (config) => get(url.RESOURCE_CONFIGURATIONS,config);
export const postFileFileConfiguration = configuration => postData(url.RESOURCE_CONFIGURATIONS, configuration)
export const getConfigurationsSelects = () => get(url.SELECTS_CONFIGURATIONS);
export const getConfiguration = () => get(url.GET_ACTIVE_CONFIGURATION);
export const deleteConfiguration = id => del(`${url.RESOURCE_CONFIGURATIONS}/${id}`)
//company
export const getCompanies = config => get(url.RESOURCE_COMPANIES,config);
export const postCompany = company => post(url.RESOURCE_COMPANIES,company);
export const putCompany = company => put(`${url.RESOURCE_COMPANIES}/${company.id}`,company);

//resellers
export const getResellers = config => get(url.RESOURCE_RESELLER,config);
export const postReseller = company => post(url.RESOURCE_RESELLER,company);
export const putReseller = company => put(`${url.RESOURCE_RESELLER}/${company.id}`,company);

//profiles - permissions
export const getProfilesPermissions = (config) => get(url.RESOURCE_PROFILES,config);
export const postProfile = profile => post(url.RESOURCE_PROFILES,profile);
export const putProfile = profile => put(`${url.RESOURCE_PROFILES}/${profile.id}`,profile);
export const getPermissions = (id,config) => get(`${url.RESOURCE_PERMISSIONS}/${id}`,config);
export const getSelectsPermissions = (id) => get(`${url.PERMISSIONS_SELECT}/${id}`);
export const postPermission = permission => post(url.RESOURCE_PERMISSIONS,permission);
export const putPermission = permission => put(`${url.RESOURCE_PERMISSIONS}/${permission.id}`,permission);
export const deletePermission = id => del(`${url.RESOURCE_PERMISSIONS}/${id}`)
//********Catalogos************//
//Typos de instalacion
export const resourcesInstallationTypes = (type,data={},id=null) => typeResource(url.RESOURCE_INSTALLATION_TYPES,type,data,id)
//Condiciones
export const resourcesConditions = (type,data={},id=null) => typeResource(url.RESOURCE_CONDITIONS,type,data,id)
//********Instalaciones************//
export const resourcesInstallations = (type,data={},id=null) => typeResource(url.RESOURCE_INSTALLATIONS,type,data,id)
export const putInstallationConditions = (data) => put(`${url.INSTALLATION_CONDITIONS}/${data.id}`,data);
export const resourcesInstallationsFiles = (type,data={},id=null) => typeResource(url.RESOURCE_INSTALLATIONS_FILES,type,data,id)
export const putInstallationTests = (data) => put(`${url.INSTALLATION_TESTS}/${data.id}`,data);
export const getSelectsInstallation = (config) => get(url.SELECTS_INSTALLATIONS,config);
//********Reportes************//
export const resourcesReports = (type,data={},id=null) => typeResource(url.RESOURCE_REPORTS,type,data,id)

export const uploadFile = (data) => postFileV2(url.RESOURCE_FILES, data);

export const getOperativeTestsCatalog = () => get(`${url.RESOURCE_CATALOGS_V2}/operative-tests`);
export const getConditionsCatalog = () => get(`${url.RESOURCE_CATALOGS_V2}/conditions`);

const typeResource = (route,type,data={},id=null) => {
    switch (type) {
    case 'get':
        return get(route,data);
        break
    case 'show':
        return get(`${route}/${id}`,data);
        break
    case 'post':
        return post(`${route}`,data);
        break
    case 'put':
        return put(`${route}/${id}`,data);
        break
    case 'del':
        return del(`${route}/${id}`);
        break
    case 'postFile':
        return postFile(`${route}`,data);
        break
    }

}


export {
    getLoggedInUser,
    isUserAuthenticated,
  //postFakeRegister,
  //postFakeProfile,
  //postFakeForgetPwd,
  //postJwtRegister,
  //postJwtLogin,
  //postJwtForgetPwd,
  //postJwtProfile
}
